import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { LoaderComponent } from '../../../loader/loader.component';
import { CommonModule } from '@angular/common';
import { Product, SalesOrder, UpdateInventory, gridPageRequest } from '../../../../model/common/common.model';
import { CustomerService } from '../../../../services/customer.service';
import { AdministratorService } from '../../../../services/administrator.service';
import { UnitsOfMeasure, Warehouse } from '../../../../model/administration.model';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { customer, salesPerson } from '../../../../model/masters.model';
import { SalespersonLookupComponent } from '../../../Lookup/salesperson-lookup/salesperson-lookup.component';
import { SalesService } from '../../../../services/sales.service';
import _ from 'lodash';
import { TermscodeLookupComponent } from '../../../Lookup/termscode-lookup/termscode-lookup.component';
import { TooltipModule } from 'primeng/tooltip';
import { ShipToCustomerLookupComponent } from '../../../Lookup/shiptocustomer-lookup/shiptocustomer-lookup.component';
import { BillToCustomerLookupComponent } from '../../../Lookup/billtocustomer-lookup/billtocustomer-lookup.component';
import { InventoryService } from '../../../../services/inventory.service';
import { CloseQuickProductLookupComponent } from '../../../Lookup/close-quick-product-lookup/close-quick-product-lookup.component';
import { UOMLookupComponent } from '../../../Lookup/uomlookup/uomlookup.component';
import { CloseQuickCustomerLookupComponent } from '../../../Lookup/close-quick-customer-lookup/close-quick-customer-lookup.component';
import { POCommentsLookupComponent } from '../../../Lookup/pocomments-lookup/pocomments-lookup.component';
import { SpecificationLookupComponent } from '../../../Lookup/specification-lookup/specification-lookup.component';
import { PaymentReceiptService } from '../../../../services/payment-receipt.service';
import { viewproductLookupComponent } from '../../../Lookup/viewproduct-lookup/viewproduct-lookup.component';
import { getISTDateWithCurrentTime } from '../../../../utils/date-utils';
import { forkJoin } from 'rxjs';
import { discountAmountFromPercent, round2 } from '../../../../shared/discount-percent.util';
import { ProjectBomLookupComponent } from '../../../Lookup/projectbom-lookup/projectbom-lookup.component';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-create-quote',
  standalone: true,
  imports: [SharedModule, LoaderComponent, CommonModule, TooltipModule],
  templateUrl: './create-quote.component.html',
  styleUrl: './create-quote.component.scss'
})
export class CreateQuoteComponent implements OnInit {
  @ViewChild('productCodeInputRef') productCodeInputRef!: any;

  userList: any;
  productId: any;
  deletedProducts: any[] = [];

  constructor(private router: Router, private messageService: MessageService, private customerService: CustomerService, private administratorService: AdministratorService,
    public dialogService: DialogService, public ref: DynamicDialogRef, private salesService: SalesService, private inventoryService: InventoryService, private el: ElementRef, private confirmationService: ConfirmationService,
    private route: ActivatedRoute, private paymentService: PaymentReceiptService) { }

  loader: boolean = false;
  isEdit: boolean = false;
  isIGST: boolean = false;
  submitted: boolean = false;
  activeIndex: number = 0;
  previewImage: string = "./assets/no-image.jpg";
  isEditingQuantity: boolean = false;
  isEditingWeight: boolean = false;
  productCostCalculationType: string | undefined;
  deliveryDate: any | undefined;
  QAvail: number = 0;
  unitLabel: string = '';
  canEdit: any;

  showRCM: boolean = false;
  isOpenStatus: boolean = false;
  customer: any;
  customerEmail: any;
  NonTaxableTotal: number = 0.00;

  gstOptions = [
    { label: 'GST0 - (0%)', value: 0 },
    { label: 'GST5 - (5%)', value: 5 },
    { label: 'GST12 - (12%)', value: 12 },
    { label: 'GST18 - (18%)', value: 18 },
    { label: 'GST28 - (28%)', value: 28 }
  ];

  createQuoteForm = new FormGroup({
    QuoteNo: new FormControl('', Validators.required),
    manualEntry: new FormControl(false),
    BillToCustomerId: new FormControl('', Validators.required),
    ShipToCustomerId: new FormControl('', Validators.required),
    BillToCustomerCode: new FormControl('', Validators.required),
    ShipToCustomerCode: new FormControl('', Validators.required),
    BillToCustomer: new FormControl('', Validators.required),
    ShipToCustomer: new FormControl('', Validators.required),
    BillToCustomerAddress: new FormControl(''),
    ShipToCustomerAddress: new FormControl('', Validators.required),
    QuoteExpiration: new FormControl<Date | null>(null, Validators.required),
    warehouse: new FormControl('', Validators.required),
    WareHouseId: new FormControl('', Validators.required),
    SalespersonCode: new FormControl('', Validators.required),
    SalespersonId: new FormControl('', Validators.required),
    salesperson: new FormControl('', Validators.required),
    CreatedBy: new FormControl('', Validators.required),
    // add product
    productId: new FormControl(''),
    productCode: new FormControl(''),
    productDescription: new FormControl(''),
    productQty: new FormControl(''),
    productWgt: new FormControl(''),
    productData: new FormControl(''),

    ShipmentDate: new FormControl(),
    TermsCode: new FormControl(''),
    PaymentTermsId: new FormControl(),
    DispatchDocNo: new FormControl(''),
    MotorVehicalNo: new FormControl(),
    BillOfLading: new FormControl(),
    purchaseOrderNumber: new FormControl(),
    LRRRNo: new FormControl(),
    DispatchThrough: new FormControl(),
    // OrderType: new FormControl('Q'),

    BillToCustomerState: new FormControl(''),
    warehouseState: new FormControl(''),
    warehouseStateCode: new FormControl(''),
    requestedDate: new FormControl<Date | null>(null, Validators.required),
    orderDate: new FormControl<Date | null>(null, Validators.required),
    deliveryNote: new FormControl(),

    ReferenceNumber: new FormControl(),
    Destination: new FormControl(),
    TermsOfDelivery: new FormControl(),
    CustomerPODate: new FormControl(),

    FinalTaxableAmt: new FormControl(0),
    // NEW: Discount/Freight fields
    DiscountAmount: new FormControl(0),
    FreightTotal: new FormControl(),
    RateOnFreight: new FormControl(),
    GSTOnFreight: new FormControl(),
    FinancialYearId: new FormControl(),
    projectBoMId: new FormControl(null),
    projectName: new FormControl(''),
    projectNo: new FormControl(''),

    supplyType: new FormControl('', Validators.required),
    isLUT: new FormControl(false),
    expTyp: new FormControl(''),
    isRCM: new FormControl(false),
    POS: new FormControl(''),
    POSDisplay: new FormControl(''),
    BillToCustomerStateCode: new FormControl(''),
    ShipToCustomerStateCode: new FormControl(''),
    ShipToCustomerState: new FormControl(''),
  });

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  BillTocustomerList: any[] = [];
  ShipTocustomerList: any[] = [];
  warehouseDropdown: Warehouse[] = [];
  filterWarehouses: Warehouse[] = [];
  filterProductList: any[] = [];
  products: Product[] = [];    // Main product variable
  allProductData: Product[] = []; // Stores all product data even after deleting from the grid
  addProductData: any;        // Represents data for adding a new product
  selectedProduct: Product[] = [];   // // Stores data for deleted products
  deleteProductIds: any[] = [];


  orderTotal: number = 0.00;
  weightTotal: number = 0.00;
  CGSTtotal: number = 0.00;
  SGSTtotal: number = 0.00;
  IGSTtotal: number = 0.00;
  SalesTaxTotal: number = 0.00;
  Taxable: number = 0.00;
  FinalTaxableAmt: number = 0;


  ngOnInit(): void {
    document.title = 'Create Quote';
    this.route.queryParams.subscribe(params => {
      if (params['Data']) {
        this.isEdit = true;
        document.title = 'Update Quote';
        this.reopenQuote();
      } else {
        this.isEdit = false;
        this.manualEntry();
        this.resetForms();

        //Fy
        this.subscribeFinancialYearChanges();

        // this.createQuoteForm.get('orderDate')?.valueChanges.subscribe(date => {
        //   if (date instanceof Date) {
        //     this.onTransactionDateChange(date, "Order");
        //   }
        // });

        // this.createQuoteForm.get('requestedDate')?.valueChanges.subscribe(date => {
        //   if (date instanceof Date) {
        //     this.onTransactionDateChange(date, "Requested");
        //   }
        // });

        const currentDate = new Date();
        this.createQuoteForm.controls.requestedDate.setValue(currentDate);
        this.createQuoteForm.controls.orderDate.setValue(currentDate);
      }
    });
    this.deliveryDate = new Date();
    //const currentDate = new Date();
    //this.createQuoteForm.controls.requestedDate.setValue(currentDate);
    //this.deliveryDate = currentDate;
    //this.createQuoteForm.controls.orderDate.setValue(new Date());
    this.getWarehouse();
    this.getUserList();
    this.createQuoteForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => {
      this.unitLabel = res?.data || 'Unit';
    });

    this.setupFormSubscriptions();

    // NEW: Discount/Freight subscriptions
    this.createQuoteForm.get('DiscountAmount')?.valueChanges.subscribe((value) => {
      const discountVal = Number(value) || 0;
      if (discountVal > 0) {
        this.products.forEach(p => p.Discount = 0);
      }
      this.calculateOrderTotal();
    });

    this.createQuoteForm.get('GSTOnFreight')?.valueChanges.subscribe(() => {
      this.calculateOrderTotal();
    });

    this.createQuoteForm.get('RateOnFreight')?.valueChanges.subscribe(() => {
      this.calculateFreightGST();
    });

    this.createQuoteForm.get('FreightTotal')?.valueChanges.subscribe(() => {
      this.calculateFreightGST();
    });
  }

  // NEW method
  calculateFreightGST() {
    const freight = Number(this.createQuoteForm.get('FreightTotal')?.value) || 0;
    const rate = Number(this.createQuoteForm.get('RateOnFreight')?.value) || 0;
    const gstAmount = (freight * rate) / 100;

    this.createQuoteForm.patchValue({
      GSTOnFreight: Number(gstAmount.toFixed(2))
    }, { emitEvent: false });

    this.calculateOrderTotal();
  }

  private subscribeFinancialYearChanges() {

    this.createQuoteForm.get('orderDate')?.valueChanges.subscribe(date => {
      if (date instanceof Date) {
        this.onTransactionDateChange(date, "Order");
      }
    });

    this.createQuoteForm.get('requestedDate')?.valueChanges.subscribe(date => {
      if (date instanceof Date) {
        this.onTransactionDateChange(date, "Requested");
      }
    });

  }


  getUserList(): void {
    if (this.isEdit) {
      return;
    }
    this.loader = true;
    this.administratorService.getAllUser().subscribe({
      next: (data: any) => {
        this.userList = data;
        this.setWarehouseFromSession();
        this.loader = false;
      },
      error: error => {
        console.error('Error fetching user info:', error);
        this.loader = false;
      }
    });
  }

  setWarehouseFromSession(): void {
    const authData = JSON.parse(localStorage.getItem('auth') || '{}');
    const userId = authData.user?.id;

    const user = this.userList.find((u: { userId: number; warehouseId?: number }) => u.userId === userId);
    if (user) {
      const warehouseId = user.warehouseId;
      if (warehouseId) {
        this.createQuoteForm.controls.WareHouseId.setValue(warehouseId);
        this.setWarehouseName(warehouseId);
      } else {
        console.warn(`No warehouse ID found for user ID: ${userId}`);
      }
    } else {
      console.warn(`User not found with user ID: ${userId}`);
    }
  }

  setWarehouseName(warehouseId: number): void {
    const warehouse = this.warehouseDropdown.find(w => w.warehouseId === warehouseId);
    if (warehouse) {
      this.createQuoteForm.controls.warehouse.setValue(warehouse.warehouseName);
      this.createQuoteForm.controls.warehouseState.setValue(warehouse.address.state);
    }
  }

  getWarehouse() {
    this.administratorService.getAllWarehouse(this.pageRequest).subscribe({
      next: (data: any) => {
        this.warehouseDropdown = data.warehouses;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  filterWarehouse(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.warehouseDropdown as any[]).length; i++) {
      let productType = (this.warehouseDropdown as any[])[i];
      if (productType.warehouseName.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        productType.warehouseCode.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(productType);
      }
    }

    this.filterWarehouses = filtered;
  }

  // setWarehouse(data: any) {
  //   if (data.value) {
  //     this.createQuoteForm.controls.WareHouseId.setValue(data.value.warehouseId);
  //     this.createQuoteForm.controls.warehouseState.setValue(data.value.address.state);
  //   }
  // }

  setWarehouse(data: any) {
    if (data?.value) {
      const warehouse = data.value;
      const address = warehouse.address || {};

      this.createQuoteForm.patchValue({
        WareHouseId: warehouse.warehouseId,
        warehouseState: address.state || '',
        warehouseStateCode: address.stateCode || ''
      });

      this.setPlaceOfSupply();

      this.calculateOrderTotal();
    }
  }

  resetForms() {
    this.createQuoteForm.reset();
    this.createQuoteForm.controls.manualEntry.setValue(false);
    this.orderTotal = 0;
    this.weightTotal = 0;
    this.CGSTtotal = 0;
    this.SGSTtotal = 0;
    this.IGSTtotal = 0;
    this.isIGST = false;
    this.products = [];
    this.allProductData = [];
    this.calculateOrderTotal();
  }

  get formControls() {
    return this.createQuoteForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.createQuoteForm.invalid) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill Required field' });
      isValid = false;
    }

    return isValid;
  }

  resetForm() {

    this.confirmationService.confirm({
      header: 'Reset',
      message: 'Reset will permanently delete all lines in the Order Line.',
      accept: () => {

        var selectedProductIds = this.products.map(product => product.SalesOrderLineItemId);

        this.loader = true;
        this.salesService.deleteSalesOrderLineItem(selectedProductIds).subscribe({
          next: async (data: any) => {
            if (data) {
              this.products = this.products.filter(product => !selectedProductIds.includes(product.SalesOrderLineItemId));
              this.selectedProduct = [];
              const isValid = this.calculateOrderTotal();
              if (await isValid) {
                this.createSalesOrder('TEMP.QUOTE');
              }
            }
          },
          error: error => {
            console.log(error);
            this.loader = false;
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while reset' });
          }
        });

      },
      reject: () => {
      }
    });

  }

  Cancel() {
    this.router.navigate(['/home/listQuotes']);
  }

  manualEntry() {
    const manualEntryValue = this.createQuoteForm.controls.manualEntry.value;

    if (manualEntryValue === true) {
      this.createQuoteForm.controls.QuoteNo.setValue('');
    } else {
      this.getOrderNumber();
    }

  }

  getOrderNumber() {
    this.loader = true;

    this.salesService.autogenerateQuoteNumber().subscribe({
      next: (data: any) => {
        this.createQuoteForm.controls.QuoteNo.setValue(data.fullNumber);
        this.loader = false;
      },
      error: () => {
        this.loader = false;
      }
    });
  }

  checkOrderNumber() {
    if (!this.createQuoteForm.controls.QuoteNo.value) {
      return;
    }
    if (this.products.length > 0) {
      return;
    }
    if (!this.isEdit) {
      this.salesService.checkOrderNumber(this.createQuoteForm.controls.QuoteNo.value).subscribe(
        (data: any) => {
          if (data.success == true) {
          } else {
            this.createQuoteForm.controls.QuoteNo.setValue('');
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Quote number already exists."' });
            this.createQuoteForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  async validateSalesOrder(value: string) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (productCodeAutoCompleteElement) {
        productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    for (const product of this.products) {
      const validProductId = product.ProductId || this.productId;
      try {
        const productData = await this.getProductById(validProductId);
        const costCalculationType = productData.costCalculation || 'Qty';

        if (costCalculationType === 'Qty' && product.QuotedQuantity <= 0) {
          this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'QuotedQuantity must be greater than 0.' });
          return;
        }

        if (costCalculationType === 'Wgt' && product.Weight <= 0) {
          this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Weight must be greater than 0.' });
          return;
        }

        if (!product.ProductDescription) {
          this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Product Name is Required' });
          return;
        }
      } catch (error) {
        console.error('Failed to fetch product data:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Unable to fetch product details.' });
        return;
      }
    }

    this.createSalesOrder(value);
  }


  // showBillToCustomerDialog() {
  //   const ref = this.dialogService.open(BillToCustomerLookupComponent, {
  //     header: 'Bill TO Customer List',
  //     width: '80%'
  //   });

  //   ref.onClose.subscribe((selectedCustomer: any) => {
  //     if (selectedCustomer) {
  //       this.createQuoteForm.controls.BillToCustomerId.setValue(selectedCustomer.customerId);
  //       this.createQuoteForm.controls.BillToCustomerCode.setValue(selectedCustomer.customerCode);
  //       this.createQuoteForm.controls.BillToCustomer.setValue(selectedCustomer.customerName);
  //       this.createQuoteForm.controls.BillToCustomerState.setValue(selectedCustomer.address.state);
  //       const address = `${selectedCustomer.address.addressLine1}, ${selectedCustomer.address.city, selectedCustomer.address.state}, ${selectedCustomer.address.country} ${selectedCustomer.address.zip}`;
  //       this.createQuoteForm.controls.BillToCustomerAddress.setValue(address);
  //       this.getTermsByCustomer(selectedCustomer.customerCode);

  //       if (selectedCustomer.isShipToCustomer) {
  //         this.createQuoteForm.controls.ShipToCustomerCode.setValue(selectedCustomer.customerCode);
  //         this.createQuoteForm.controls.ShipToCustomer.setValue(selectedCustomer.customerName);
  //         this.createQuoteForm.controls.ShipToCustomerId.setValue(selectedCustomer.customerId);
  //         this.createQuoteForm.controls.ShipToCustomerAddress.setValue(address);
  //       }
  //     }
  //   });
  // }

  showBillToCustomerDialog() {
    const ref = this.dialogService.open(BillToCustomerLookupComponent, {
      header: 'Bill TO Customer List',
      width: '80%'
    });



    ref.onClose.subscribe((selectedCustomer: any) => {
      if (selectedCustomer) {

        this.applyBillToCustomer(selectedCustomer);

        this.getTermsByCustomer(selectedCustomer.customerCode);
      }
    });
  }




  getTermsByCustomer(CustomerCode: string) {
    this.paymentService.getTermByCustomer(CustomerCode).subscribe(
      (data: any) => {
        if (data.success) {
          const termsData = data.termsDetails
          this.createQuoteForm.controls.TermsCode.setValue(termsData.paymentTermsDescription),
            this.createQuoteForm.controls.PaymentTermsId.setValue(termsData.paymentTermsId)

        }
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while patch customer' });
      }
    );
  }

  openShipToCustomerLookup() {
    const ref = this.dialogService.open(ShipToCustomerLookupComponent, {
      header: 'Ship To Customer List',
      width: '80%'
    });

    ref.onClose.subscribe((selectedCustomer: any) => {
      if (selectedCustomer) {
        this.createQuoteForm.controls.ShipToCustomerId.setValue(selectedCustomer.customerId);
        this.createQuoteForm.controls.ShipToCustomerCode.setValue(selectedCustomer.customerCode);
        this.createQuoteForm.controls.ShipToCustomer.setValue(selectedCustomer.customerName);
        const address = `${selectedCustomer.address.addressLine1}, ${selectedCustomer.address.city, selectedCustomer.address.state}, ${selectedCustomer.address.country} ${selectedCustomer.address.zip}`;
        this.createQuoteForm.controls.ShipToCustomerAddress.setValue(address);
      }
    });
  }

  autosearchBilltoCustomer(event: any) {
    this.salesService.autoSearchCustomer(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.BillTocustomerList = data.filter((customer: any) => customer.isActive === true);
        } else {
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  // setBillTo(data: any) {
  //   if (data.value) {
  //     this.createQuoteForm.controls.BillToCustomerCode.setValue(data.value.customerCode);
  //     this.createQuoteForm.controls.BillToCustomer.setValue(data.value.customerName);
  //     this.createQuoteForm.controls.BillToCustomerId.setValue(data.value.customerId);
  //     const address = `${data.value.address.addressLine1}, ${data.value.address.city, data.value.address.state}, ${data.value.address.country} ${data.value.address.zip}`;
  //     this.createQuoteForm.controls.BillToCustomerAddress.setValue(address);
  //     this.createQuoteForm.controls.BillToCustomerState.setValue(data.value.address.state);

  //     if (data.value.isShipToCustomer) {
  //       this.createQuoteForm.controls.ShipToCustomerCode.setValue(data.value.customerCode);
  //       this.createQuoteForm.controls.ShipToCustomer.setValue(data.value.customerName);
  //       this.createQuoteForm.controls.ShipToCustomerId.setValue(data.value.customerId);
  //       this.createQuoteForm.controls.ShipToCustomerAddress.setValue(address);
  //     }
  //   }
  // }

  setBillTo(event: any) {
    const customer = event?.value || event;

    this.applyBillToCustomer(customer);
  }


  applyBillToCustomer(customer: any) {

    if (!customer) return;

    const addressObj = customer.address || {};

    const address = `${addressObj.addressLine1}, ${addressObj.city}, ${addressObj.state}, ${addressObj.country} ${addressObj.zip}`;

    this.createQuoteForm.patchValue({
      BillToCustomerId: customer.customerId,
      BillToCustomerCode: customer.customerCode,
      BillToCustomer: customer.customerName,
      BillToCustomerAddress: address,


      BillToCustomerState: addressObj.state || '',
      BillToCustomerStateCode: addressObj.stateCode || ''
    });

    this.customer = customer;
    this.customerEmail = customer.email;

    //  Ship To auto-fill
    if (customer.isShipToCustomer) {
      this.createQuoteForm.patchValue({
        ShipToCustomerCode: customer.customerCode,
        ShipToCustomer: customer.customerName,
        ShipToCustomerId: customer.customerId,
        ShipToCustomerAddress: address,

        //  ALSO ADD HERE
        ShipToCustomerState: addressObj.state || '',
        ShipToCustomerStateCode: addressObj.stateCode || ''
      });
    }

    //  Supply Type
    const supplyType = this.getSupplyType(customer);

    this.createQuoteForm.patchValue({
      supplyType: supplyType
    });

    //  GST logic
    this.setExportType();
    this.updateRCMState(supplyType);

    //  NEW: POS calculation (MUST ADD)
    this.setPlaceOfSupply();

    // setTimeout(() => {
    //   this.calculateOrderTotal();
    // });

    this.calculateOrderTotal();
  }


  autosearchShiptoCustomer(event: any) {
    this.salesService.autoSearchCustomer(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.ShipTocustomerList = data.filter((customer: any) => customer.isShipToCustomer === true && customer.isActive === true);
        } else {
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  setShipTo(data: any) {
    if (data.value) {
      this.createQuoteForm.controls.ShipToCustomerCode.setValue(data.value.customerCode);
      this.createQuoteForm.controls.ShipToCustomer.setValue(data.value.customerName);
      this.createQuoteForm.controls.ShipToCustomerId.setValue(data.value.customerId);
      const address = `${data.value.address.addressLine1}, ${data.value.address.city, data.value.address.state}, ${data.value.address.country} ${data.value.address.zip}`;
      this.createQuoteForm.controls.ShipToCustomerAddress.setValue(address);
    }
  }

  showSalesperson() {
    if (this.products.length > 0) {
      return;
    }

    this.ref = this.dialogService.open(SalespersonLookupComponent, {
      header: 'Salesperson List',
      width: '60%',

    });
    this.ref.onClose.subscribe((data: salesPerson) => {
      if (data) {
        this.createQuoteForm.controls.SalespersonCode.setValue(data.salespersonCode);
        this.createQuoteForm.controls.SalespersonId.setValue(_.toString(data.salespersonId));
        this.createQuoteForm.controls.salesperson.setValue(data.salespersonName);
      }

    });
  }

  showTermsCode() {
    this.ref = this.dialogService.open(TermscodeLookupComponent, {
      header: 'Terms Code',
      width: '60%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.createQuoteForm.patchValue({
          TermsCode: data.paymentTermsDescription,
          PaymentTermsId: data.paymentTermsId,

        })
      }
    })
  }


  autosearchProduct(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.filterProductList = data;
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  setProduct(data: any) {
    this.createQuoteForm.controls.productCode.setValue(data.value.productCode);
    this.createQuoteForm.controls.productDescription.setValue(data.value.productName);
    this.createQuoteForm.controls.productId.setValue(data.value.productId);
    this.addProductData = data.value;
    const costCalculationType = data.value.costCalculation || 'Qty';
    this.productCostCalculationType = costCalculationType;
    if (costCalculationType === 'Qty') {
      this.createQuoteForm.controls.productQty.setValue('');
    } else if (costCalculationType === 'Wgt') {
      this.createQuoteForm.controls.productWgt.setValue('');
    }
    this.setFieldFocus();

    if (data.value.productImage) {
      this.previewImage = `data:image/jpeg;base64,${data.value.productImage}`;
    } else {
      this.previewImage = "./assets/no-image.jpg";
    }
    this.getInventoryStatus(data.value.productCode);
  }

  setFieldFocus() {
    const control = this.el.nativeElement.querySelector('#Qty');
    if (control) {
      setTimeout(() => {
        control.focus();
      }, 100);
    }
  }



  validateCustomer() {
    let isValid = true;

    if (
      !this.createQuoteForm.controls.BillToCustomer?.valid ||
      !this.createQuoteForm.controls.ShipToCustomer?.valid ||
      !this.createQuoteForm.controls.SalespersonCode?.valid ||
      !this.createQuoteForm.controls.QuoteNo?.valid ||
      !this.createQuoteForm.controls.BillToCustomer?.valid ||
      !this.createQuoteForm.controls.ShipToCustomer?.valid ||
      !this.createQuoteForm.controls.WareHouseId?.valid

    ) {
      if (!this.createQuoteForm.controls.BillToCustomer.value) {
        this.createQuoteForm.controls.BillToCustomerCode.setValue('');
      } else if (!this.createQuoteForm.controls.ShipToCustomer.value) {
        this.createQuoteForm.controls.ShipToCustomerCode.setValue('');
      } else if (!this.createQuoteForm.controls.WareHouseId.value) {
        this.createQuoteForm.controls.warehouse.setValue('');
      }
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill Required field' });
      isValid = false;
    }

    return isValid;
  }

  // async checkIGST() {
  //   const warehouseState = this.createQuoteForm.controls.warehouseState.value;
  //   const CustomerState = this.createQuoteForm.controls.BillToCustomerState.value;

  //   if (!warehouseState || !CustomerState) {
  //     this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed to calculate IGST due to missing state values' });
  //     return;
  //   }

  //   if (warehouseState == CustomerState) {
  //     this.isIGST = false;
  //   } else {
  //     this.isIGST = true;
  //   }
  // }

  // async addProduct() {

  //   if (!this.validateFinancialYear()) {
  //     return;
  //   }

  //   this.loader = true;
  //   this.submitted = true;

  //   await this.checkIGST();

  //   const isValid = this.validateCustomer();
  //   if (!isValid) {
  //     window.scroll(0, 0);
  //     this.loader = false;
  //     return;
  //   }

  //   const productId = _.toNumber(this.createQuoteForm.controls.productId.value);
  //   let costCalculationType: string;

  //   this.inventoryService.getProductById(productId).subscribe({
  //     next: (productData) => {
  //       if (!productData) {
  //         console.error('Product data is empty');
  //         this.loader = false;
  //         return;
  //       }

  //       this.addProductData = {
  //         ...this.addProductData,
  //         productName: productData.productName || this.addProductData.productName,
  //         standardCost: productData.standardCost || this.addProductData.standardCost,
  //         productCode: productData.productCode || this.addProductData.productCode,
  //         hsnCode: productData.hsnCode || this.addProductData.hsnCode,
  //         gst: productData.gstRate || this.addProductData.gstRate,
  //         productSpecification: productData.productSpecification,
  //         isServiceType: productData.isServiceType,
  //       };
  //       costCalculationType = productData?.costCalculation || 'Qty';

  //       const lastItem = this.allProductData[this.allProductData.length - 1];
  //       const quantity = _.toNumber(this.createQuoteForm.controls.productWgt.value);
  //       const weight = _.toNumber(this.createQuoteForm.controls.productWgt.value);
  //       const parseCurrency = (value: any): number => {
  //         return parseFloat((value ?? 0).toString().replace(/[₹,]/g, ''));
  //       };
  //       const salesPrice = parseCurrency(this.addProductData?.salesPrice);
  //       const deliveryDate = (this.createQuoteForm.controls.requestedDate.value);

  //       if (isNaN(salesPrice) || isNaN(quantity) || isNaN(weight)) {
  //         console.error('Invalid data for salesPrice or quantity/weight');
  //         this.loader = false;
  //         return;
  //       }

  //       let extensionPrice: number;
  //       if (costCalculationType === 'Qty') {
  //         extensionPrice = quantity * salesPrice;
  //       } else if (costCalculationType === 'Wgt') {
  //         extensionPrice = weight * salesPrice;
  //       } else {
  //         console.warn('Unknown costCalculation type:', costCalculationType);
  //         extensionPrice = 0;
  //       }
  //       const gstRate = this.addProductData.gst != null ? this.addProductData.gst : 0;

  //       const product: Product = <Product><unknown>{
  //         SalesOrderNumber: _.toString(this.createQuoteForm.controls.QuoteNo.value),
  //         ProductId: productId,
  //         QuotedQuantity: costCalculationType === 'Wgt' ? 0 : quantity,
  //         Uom: _.toString(this.addProductData.sellingUom),
  //         LineItemNumber: (this.allProductData.length !== 0) ? lastItem.LineItemNumber + 1 : 1,
  //         IsTaxable: this.addProductData.isTaxable,
  //         StandardCost: this.addProductData.standardCost,
  //         UnitPrice: salesPrice,
  //         Amount: _.round(extensionPrice, 2),
  //         ExtensionPrice: _.round(extensionPrice, 2),
  //         Comment: "",
  //         deliveryDate: deliveryDate,
  //         GSTRate: gstRate,
  //         HSNCode: this.addProductData.hsnCode,
  //         // NEW fields
  //         Discount: 0,
  //         DiscountAmount: 0,
  //         NetAmount: _.round(extensionPrice, 2),
  //         CGST: (!this.isIGST) ? this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? quantity : weight), gstRate, this.addProductData.isTaxable) / 2 : 0,
  //         SGST: (!this.isIGST) ? this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? quantity : weight), gstRate, this.addProductData.isTaxable) / 2 : 0,
  //         IGST: (this.isIGST) ? this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? quantity : weight), gstRate, this.addProductData.isTaxable) : 0,
  //         SalesTax: this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? quantity : weight), gstRate, this.addProductData.isTaxable),
  //         Weight: costCalculationType === 'Qty' ? 0 : weight,
  //         WareHouseId: _.toNumber(this.createQuoteForm.controls.WareHouseId.value),
  //         ProductCode: this.addProductData.productCode,
  //         ProductDescription: this.addProductData.productName,
  //         ProductSpecification: this.addProductData.productSpecification,
  //         CreatedBy: _.toString(this.createQuoteForm.controls.CreatedBy.value),
  //         IsActive: true,
  //         DepartmentId: 0,
  //         LocationId: 0,
  //         SerialId: 0,
  //         VendnorId: 0,
  //         IsServiceType: this.addProductData.isServiceType,
  //         // NEW field
  //         LineTotal: _.round(extensionPrice + this.calculateGST(salesPrice, (costCalculationType === 'Qty' ? quantity : weight), gstRate, this.addProductData.isTaxable), 2),
  //       };

  //       if (this.isEdit) {
  //         this.products.push(product);
  //         this.createQuoteForm.controls.productCode.setValue('');
  //         this.createQuoteForm.controls.productDescription.setValue('');
  //         this.createQuoteForm.controls.productQty.setValue('');
  //         this.createQuoteForm.controls.productWgt.setValue('');
  //         this.previewImage = "./assets/no-image.jpg";
  //         this.loader = false;
  //         this.QAvail = 0;
  //         this.calculateOrderTotal();
  //         this.allProductData.push(product);
  //       } else {
  //         this.previewImage = "./assets/no-image.jpg";
  //         this.createSalesOrderLineItem(product);
  //       }
  //       setTimeout(() => {
  //         const inputEl: HTMLInputElement = this.productCodeInputRef?.el?.nativeElement?.querySelector('input');
  //         inputEl?.focus();
  //       }, 0);

  //     },
  //     error: (err) => {
  //       console.error('Failed to fetch product data:', err);
  //       this.loader = false;
  //     }
  //   });

  // }

  async checkIGST() {
    this.isIGST = this.isIGSTApplicable();
  }

  async addProduct() {

    if (!this.validateFinancialYear()) {
      return;
    }

    this.loader = true;
    this.submitted = true;

    await this.checkIGST();

    const isValid = this.validateCustomer();
    if (!isValid) {
      window.scroll(0, 0);
      this.loader = false;
      return;
    }
    const productId =
      _.toNumber(this.createQuoteForm.controls.productId.value);

    this.inventoryService.getProductById(productId).subscribe({
      next: async (productData) => {

        if (!productData) {
          console.error('Product data is empty');
          this.loader = false;
          return;
        }

        this.addProductData = {
          ...this.addProductData,

          productName:
            productData.productName ||
            this.addProductData.productName,

          standardCost:
            productData.standardCost ||
            this.addProductData.standardCost,

          productCode:
            productData.productCode ||
            this.addProductData.productCode,

          hsnCode:
            productData.hsnCode ||
            this.addProductData.hsnCode,

          gst:
            productData.gstRate ||
            this.addProductData.gstRate,

          productSpecification:
            productData.productSpecification,

          isServiceType:
            productData.isServiceType
        };

        const costCalculationType =
          productData?.costCalculation || 'Qty';

        const lastItem =
          this.allProductData[this.allProductData.length - 1];

        const quantity =
          _.toNumber(
            this.createQuoteForm.controls.productWgt.value
          );

        const weight = quantity;

        const parseCurrency = (value: any): number => {
          return parseFloat(
            (value ?? 0)
              .toString()
              .replace(/[₹,]/g, '')
          ) || 0;
        };

        const salesPrice =
          parseCurrency(this.addProductData?.salesPrice);

        const deliveryDate =
          this.createQuoteForm.controls.requestedDate.value;

        if (
          isNaN(salesPrice) ||
          isNaN(quantity) ||
          isNaN(weight)
        ) {
          console.error(
            'Invalid data for salesPrice or quantity/weight'
          );

          this.loader = false;
          return;
        }

        // =========================================
        // EXTENSION PRICE
        // =========================================

        let extensionPrice = 0;

        if (costCalculationType === 'Qty') {

          extensionPrice =
            quantity * salesPrice;

        }
        else if (costCalculationType === 'Wgt') {

          extensionPrice =
            weight * salesPrice;

        }
        else {

          console.warn(
            'Unknown costCalculation type:',
            costCalculationType
          );

          this.loader = false;
          return;
        }

        extensionPrice =
          _.round(extensionPrice, 2);

        const gstRate =
          this.addProductData.gst != null
            ? _.toNumber(this.addProductData.gst)
            : 0;

        // =========================================
        // RCM / LUT
        // =========================================

        const form =
          this.createQuoteForm.value;

        const isRCM =
          form.isRCM === true;

        const isLUT =
          form.isLUT === true &&
          (
            form.supplyType === 'EXPORT' ||
            form.supplyType === 'SEZ'
          );

        // =========================================
        // TAXABLE QUANTITY
        // =========================================

        const taxableQuantity =
          costCalculationType === 'Qty'
            ? quantity
            : weight;

        // =========================================
        // NORMAL GST
        // =========================================

        const normalGST =
          this.addProductData.isTaxable &&
            gstRate > 0
            ? this.calculateGST(
              salesPrice,
              taxableQuantity,
              gstRate,
              this.addProductData.isTaxable
            )
            : 0;

        // =========================================
        // ACTUAL LINE GST
        //
        // RCM / LUT => GST is not included
        // in Quote LineTotal
        // =========================================

        const lineGST =
          isRCM || isLUT
            ? 0
            : normalGST;

        // =========================================
        // CREATE PRODUCT
        // =========================================

        const product: Product =
          <Product><unknown>{

            SalesOrderNumber:
              _.toString(
                this.createQuoteForm.controls.QuoteNo.value
              ),

            ProductId:
              productId,

            QuotedQuantity:
              costCalculationType === 'Wgt'
                ? 0
                : quantity,

            Uom:
              _.toString(
                this.addProductData.sellingUom
              ),

            LineItemNumber:
              this.allProductData.length !== 0
                ? lastItem.LineItemNumber + 1
                : 1,

            IsTaxable:
              this.addProductData.isTaxable,

            StandardCost:
              this.addProductData.standardCost,

            UnitPrice:
              salesPrice,

            Amount:
              extensionPrice,

            ExtensionPrice:
              extensionPrice,

            Comment:
              "",

            deliveryDate:
              deliveryDate,

            GSTRate:
              gstRate,

            HSNCode:
              this.addProductData.hsnCode,

            Discount:
              0,

            DiscountAmount:
              0,

            NetAmount:
              extensionPrice,

            // =====================================
            // IMPORTANT
            // =====================================

            CGST:
              !this.isIGST
                ? _.round(lineGST / 2, 2)
                : 0,

            SGST:
              !this.isIGST
                ? _.round(lineGST / 2, 2)
                : 0,

            IGST:
              this.isIGST
                ? _.round(lineGST, 2)
                : 0,

            SalesTax:
              _.round(lineGST, 2),

            // =====================================

            Weight:
              costCalculationType === 'Qty'
                ? 0
                : weight,

            WareHouseId:
              _.toNumber(
                this.createQuoteForm.controls.WareHouseId.value
              ),

            ProductCode:
              this.addProductData.productCode,

            ProductDescription:
              this.addProductData.productName,

            ProductSpecification:
              this.addProductData.productSpecification,

            CreatedBy:
              _.toString(
                this.createQuoteForm.controls.CreatedBy.value
              ),

            IsActive:
              true,

            DepartmentId:
              0,

            LocationId:
              0,

            SerialId:
              0,

            VendnorId:
              0,

            IsServiceType:
              this.addProductData.isServiceType,

            // =====================================
            // IMPORTANT
            // =====================================

            LineTotal:
              _.round(
                extensionPrice + lineGST,
                2
              )
          };

        // =========================================
        // DEBUG
        // =========================================

        // console.log('QUOTE ADD PRODUCT', {
        //   supplyType: form.supplyType,
        //   isRCM,
        //   isLUT,
        //   isIGST: this.isIGST,
        //   gstRate,
        //   normalGST,
        //   lineGST,
        //   extensionPrice,
        //   lineTotal: product.LineTotal
        // });

        // =========================================
        // EDIT MODE
        // =========================================

        if (this.isEdit) {

          this.products.push(product);

          this.allProductData.push(product);

          await this.calculateOrderTotal();

          this.createQuoteForm.controls.productCode.setValue('');
          this.createQuoteForm.controls.productDescription.setValue('');
          this.createQuoteForm.controls.productQty.setValue('');
          this.createQuoteForm.controls.productWgt.setValue('');

          this.previewImage =
            "./assets/no-image.jpg";

          this.QAvail = 0;

          this.loader = false;
        }

        // =========================================
        // CREATE MODE
        // =========================================

        else {

          this.previewImage =
            "./assets/no-image.jpg";

          // IMPORTANT:
          // Do NOT save wrong GST values first.

          await this.createSalesOrderLineItem(product);
        }

        // =========================================
        // FOCUS PRODUCT INPUT
        // =========================================

        setTimeout(() => {

          const inputEl: HTMLInputElement =
            this.productCodeInputRef
              ?.el
              ?.nativeElement
              ?.querySelector('input');

          inputEl?.focus();

        }, 0);
      },

      error: (err) => {

        console.error(
          'Failed to fetch product data:',
          err
        );

        this.loader = false;
      }
    });
  }


  getProductById(productId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.inventoryService.getProductById(this.productId || productId).subscribe({
        next: (data: any) => resolve(data),
        error: (error) => reject(error),
      });
    });
  }
  createSalesOrderLineItem(product: Product) {
    this.salesService.createSalesOrderLineItem(product).subscribe(
      async (data: any) => {
        if (data) {
          product.SalesOrderLineItemId = data.lineItemId;
          this.products.push(product);
          this.createQuoteForm.controls.productCode.setValue('');
          this.createQuoteForm.controls.productDescription.setValue('')
          this.createQuoteForm.controls.productQty.setValue('')
          this.createQuoteForm.controls.productWgt.setValue('')
          this.loader = false;
          const isValid = this.calculateOrderTotal();
          if (await isValid) {
            this.createSalesOrder('TEMP.QUOTE');
          }
          this.allProductData.push(product);
        }
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while adding product' });
      }
    );
  }

  createSalesOrder(value: string, MoveToOrder: boolean = false) {

    const SalesOrder: SalesOrder = <SalesOrder>{
      SalesOrderNumber: _.toString(this.createQuoteForm.controls.QuoteNo.value),
      OrderType: "ORDERTYPE.NORMAL",
      SalesOrderStatus: (this.isEdit) ? 'QUOTE' : value,
      SalesOrderDate: new Date(),
      SalespersonId: _.toNumber(this.createQuoteForm.controls.SalespersonId.value) as any,
      SalespersonCode: this.createQuoteForm.controls.SalespersonCode.value,
      CustomerId: this.createQuoteForm.controls.BillToCustomerId.value,
      BillToCustomerCode: this.createQuoteForm.controls.BillToCustomerCode.value,
      BillToCustomerId: this.createQuoteForm.controls.BillToCustomerId.value,
      ShipToCustomerCode: this.createQuoteForm.controls.ShipToCustomerCode.value,
      ShipToCustomerId: this.createQuoteForm.controls.ShipToCustomerId.value,
      WarehouseId: this.createQuoteForm.controls.WareHouseId.value,
      deliveryNote: this.createQuoteForm.controls.deliveryNote.value,
      OrderTotal: this.orderTotal,
      totalWeight: this.weightTotal,
      CGSTTotal: this.CGSTtotal,
      SGSTTotal: this.SGSTtotal,
      IGSTTotal: this.IGSTtotal,
      SalesTaxTotal: this.SalesTaxTotal,
      IsActive: true,
      CreatedBy: this.createQuoteForm.controls.CreatedBy.value,
      MotorVehicleNo: this.createQuoteForm.controls.MotorVehicalNo.value,
      TermsCode: this.createQuoteForm.controls.TermsCode.value,
      PaymentTermsId: this.createQuoteForm.controls.PaymentTermsId.value,
      DispatchDocNo: this.createQuoteForm.controls.DispatchDocNo.value,
      BillOfLading: this.createQuoteForm.controls.BillOfLading.value,
      PurchaseOrderNumber: this.createQuoteForm.controls.purchaseOrderNumber.value,

      LRRRNo: this.createQuoteForm.controls.LRRRNo.value,
      DispatchThrough: this.createQuoteForm.controls.DispatchThrough.value,
      BackOrderTotal: 0,
      MarginTotal: 0,
      ProfitTotal: 0,
      LabourTotal: 0,
      FreightTotal: this.createQuoteForm.controls.FreightTotal.value || 0,
      RateOnFreight: this.createQuoteForm.controls.RateOnFreight.value || 0,
      GSTOnFreight: this.createQuoteForm.controls.GSTOnFreight.value || 0,
      DiscountAmount: this.createQuoteForm.controls.DiscountAmount.value || 0,
      FinalTaxableAmt: this.createQuoteForm.controls.FinalTaxableAmt.value || 0,
      orderDate: this.createQuoteForm.controls.orderDate.value,
      requestedDate: this.createQuoteForm.controls.requestedDate.value,

      ReferenceNumber: this.createQuoteForm.controls.ReferenceNumber.value,
      Destination: this.createQuoteForm.controls.Destination.value,
      TermsOfDelivery: this.createQuoteForm.controls.TermsOfDelivery.value,
      CustomerPODate: this.createQuoteForm.controls.CustomerPODate.value,
      Status: 'Draft - 0%',
      FinancialYearId: Number(this.createQuoteForm.controls['FinancialYearId'].value),
      projectBoMId: this.createQuoteForm.controls.projectBoMId.value ?? undefined,
      projectName: this.createQuoteForm.controls.projectName.value ?? undefined,
      projectNo: this.createQuoteForm.controls.projectNo.value ?? undefined,

      SupplyType: this.createQuoteForm.controls.supplyType.value,
      IsLUT: this.createQuoteForm.controls.isLUT.value,
      ExportType: this.createQuoteForm.controls.expTyp.value,
      IsRCM: this.createQuoteForm.controls.isRCM.value,
      POS: this.createQuoteForm.controls.POS.value,
    };

    const shipmentDateControl = this.createQuoteForm.controls.ShipmentDate;
    const quoteExpirationControl = this.createQuoteForm.controls.QuoteExpiration;

    if (shipmentDateControl.value || quoteExpirationControl.value) {
      const currentTime = new Date();

      if (shipmentDateControl.value) {
        var ShipmentDate = shipmentDateControl.value;
        ShipmentDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
        SalesOrder.ShipmentDate = ShipmentDate;
      }

      if (quoteExpirationControl.value) {
        var QuoteExpiration = quoteExpirationControl.value;
        QuoteExpiration.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
        SalesOrder.QuoteExpiration = QuoteExpiration;
      }

      if (this.createQuoteForm.controls.orderDate.value) {
        var orderDate = this.createQuoteForm.controls.orderDate.value;
        const currentTime = new Date();
        orderDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
        SalesOrder.orderDate = orderDate;
      }

      if (this.createQuoteForm.controls.requestedDate.value) {
        var requestedDate = this.createQuoteForm.controls.requestedDate.value;
        const currentTime = new Date();
        requestedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
        SalesOrder.requestedDate = requestedDate;
      }

    }

    if (MoveToOrder) {
      SalesOrder.SalesOrderStatus = 'ORDER'
    }

    this.loader = true;
    if (this.products.length === 1 && value === 'TEMP.QUOTE' && !this.isEdit) {
      this.salesService.createSalesOrder(SalesOrder).subscribe(
        (data: any) => {
          if (data.success == true) {
            this.loader = false;
          }
          else {
            this.loader = false;
          }
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
        }
      );
    }
    else {

      if (this.isEdit) {
        SalesOrder.UpdatedBy = this.createQuoteForm.controls.CreatedBy.value || '';
        SalesOrder.TermsCode = this.createQuoteForm.get('TermsCode')?.value || '';
        SalesOrder.PaymentTermsId = this.createQuoteForm.get('PaymentTermsId')?.value ?? null;
      }

      if (!SalesOrder.requestedDate) {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Warning',
          detail: 'The RequestDate is Required'
        });
        return;
      }

      getISTDateWithCurrentTime(SalesOrder.CustomerPODate);

      this.salesService.updateSalesOrder(SalesOrder).subscribe(
        (data: any) => {
          if (data) {
            this.loader = false;

            if (value === 'QUOTE' || value === 'ORDER') {
              if (value === 'ORDER') {
                this.updateInventory('DirectOrder');
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quotation Sent To Order Successfully.' });
                setTimeout(() => {
                  this.router.navigate(['/home/listOrder']);
                }, 1000);
              } else {
                this.updateInventory();
                if (this.isEdit) {
                  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quote Updated Successfully.' });
                } else {
                  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quote Created Successfully.' });
                }
                setTimeout(() => {
                  this.router.navigate(['/home/listQuotes']);
                }, 1000);
              }
            }

          }
          else {
            console.log(data);
            this.loader = false;
          }
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
          if (value === 'QUOTE') {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed To Create Quote.' });
          }
        }
      );
    }
  }



  // async calculateOrderTotal() {
  //   await this.checkIGST();

  //   let orderTotal = 0;
  //   let totalWeight = 0;
  //   let cgst = 0;
  //   let sgst = 0;
  //   let igst = 0;
  //   let taxableTotal = 0;

  //   const getNum = (val: any) => _.toNumber(val) || 0;
  //   const parseCurrency = (val: any) =>
  //     parseFloat((val ?? 0).toString().replace(/[₹,]/g, '') || '0');

  //   for (const product of this.products) {
  //     const productId = _.toNumber(product.ProductId);
  //     let costCalculationType;

  //     try {
  //       const productData = await this.getProductById(productId);
  //       costCalculationType = productData.costCalculation || 'Qty';
  //     } catch (error) {
  //       console.error('Failed to fetch product data:', error);
  //       continue;
  //     }

  //     const quantity = getNum(product.QuotedQuantity);
  //     const unitPrice = parseCurrency(product.UnitPrice);

  //     const lineAmount = _.round(quantity * unitPrice, 2);

  //     // Discount % → DiscountAmount → NetAmount
  //     const discountPercent = getNum(product.Discount);
  //     const lineDiscountAmount = discountAmountFromPercent(lineAmount, discountPercent);
  //     const netAmount = _.round(lineAmount - lineDiscountAmount, 2);

  //     product.Amount = lineAmount;
  //     product.ExtensionPrice = lineAmount;
  //     product.DiscountAmount = lineDiscountAmount;
  //     product.NetAmount = netAmount;

  //     taxableTotal += netAmount;

  //     const isTaxable =
  //       (typeof product.IsTaxable === 'string' && product.IsTaxable === 'Y') ||
  //       (typeof product.IsTaxable === 'boolean' && product.IsTaxable === true);

  //     const gstRate = getNum(product.GSTRate);
  //     let lineGST = 0;

  //     if (isTaxable && gstRate > 0) {
  //       lineGST = _.round((netAmount * gstRate) / 100, 2);

  //       if (this.isIGST) {
  //         product.IGST = lineGST;
  //         product.CGST = 0;
  //         product.SGST = 0;
  //         igst += lineGST;
  //       } else {
  //         product.CGST = _.round(lineGST / 2, 2);
  //         product.SGST = _.round(lineGST / 2, 2);
  //         product.IGST = 0;
  //         cgst += product.CGST;
  //         sgst += product.SGST;
  //       }
  //     } else {
  //       product.CGST = 0;
  //       product.SGST = 0;
  //       product.IGST = 0;
  //     }

  //     product.SalesTax = lineGST;
  //     product.LineTotal = _.round(netAmount + lineGST, 2);

  //     orderTotal += netAmount;
  //     totalWeight += quantity;
  //   }

  //   const discountControl = this.createQuoteForm.get('DiscountAmount');
  //   const discount = getNum(discountControl?.value);
  //   const freightTotal = getNum(this.createQuoteForm.get('FreightTotal')?.value);
  //   const freightRate = getNum(this.createQuoteForm.get('RateOnFreight')?.value);

  //   if (freightTotal > 0 && freightRate > 0) {
  //     const freightGST = _.round((freightTotal * freightRate) / 100, 2);
  //     if (this.isIGST) {
  //       igst += freightGST;
  //     } else {
  //       cgst += _.round(freightGST / 2, 2);
  //       sgst += _.round(freightGST / 2, 2);
  //     }
  //   }

  //   const maxDiscount = _.round(taxableTotal + freightTotal + cgst + sgst + igst, 2);

  //   if (discount > maxDiscount && maxDiscount > 0) {
  //     if (discountControl?.dirty && !discountControl?.hasError('exceedTotal')) {
  //       this.messageService.clear();
  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Invalid Discount',
  //         detail: 'Discount cannot be greater than order total.'
  //       });
  //     }
  //     discountControl?.setErrors({ exceedTotal: true });
  //   } else {
  //     if (discountControl?.hasError('exceedTotal')) {
  //       discountControl.setErrors(null);
  //     }
  //   }

  //   const finalTaxableAmount = _.round(taxableTotal - discount + freightTotal, 2);

  //   this.weightTotal = _.round(totalWeight, 2);
  //   this.Taxable = _.round(taxableTotal, 2);
  //   this.CGSTtotal = this.isIGST ? 0 : _.round(cgst, 2);
  //   this.SGSTtotal = this.isIGST ? 0 : _.round(sgst, 2);
  //   this.IGSTtotal = this.isIGST ? _.round(igst, 2) : 0;
  //   this.FinalTaxableAmt = finalTaxableAmount;

  //   this.createQuoteForm.patchValue({
  //     FinalTaxableAmt: finalTaxableAmount
  //   }, { emitEvent: false });

  //   this.orderTotal = _.round(finalTaxableAmount + this.CGSTtotal + this.SGSTtotal + this.IGSTtotal, 2);
  //   this.products = _.cloneDeep(this.products);

  //   return true;
  // }

  async calculateOrderTotal() {

    const form = this.createQuoteForm.value;

    // ---------------------------------------
    // Determine IGST
    // ---------------------------------------
    this.isIGST = this.isIGSTApplicable();

    // ---------------------------------------
    // RCM / LUT
    // ---------------------------------------
    //const isRCM = form.isRCM === true;

    const rcmValue = this.createQuoteForm.get('isRCM')?.value;

    const isRCM = rcmValue === true;

    const isLUT =
      form.isLUT === true &&
      (
        form.supplyType === 'EXPORT' ||
        form.supplyType === 'SEZ'
      );

    let totalWeight = 0;

    let taxableTotal = 0;
    let nonTaxableTotal = 0;

    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    const getNum = (value: any): number => {
      return _.toNumber(value) || 0;
    };

    const parseCurrency = (value: any): number => {
      return (
        parseFloat(
          (value ?? 0)
            .toString()
            .replace(/[₹,]/g, '')
        ) || 0
      );
    };

    let totalBeforeHeaderDiscount = 0;

    // =====================================================
    // STEP 1: Calculate Amount and Line Discount
    // =====================================================

    for (const product of this.products) {

      const quantity =
        getNum(product.QuotedQuantity);

      const weight =
        getNum(product.Weight);

      const unitPrice =
        parseCurrency(product.UnitPrice);

      const discountPercent =
        getNum(product.Discount);

      const productData =
        await this.inventoryService
          .getProductById(
            Number(product.ProductId)
          )
          .toPromise();

      const costType =
        productData?.costCalculation || 'Qty';

      // ---------------------------------------
      // Amount
      // ---------------------------------------

      const amount =
        _.round(
          costType === 'Qty'
            ? quantity * unitPrice
            : weight * unitPrice,
          2
        );

      product.Amount = amount;

      product.ExtensionPrice = amount;

      // ---------------------------------------
      // Line Discount
      // ---------------------------------------

      const lineDiscountAmount =
        _.round(
          (amount * discountPercent) / 100,
          2
        );

      product.DiscountAmount =
        lineDiscountAmount;

      // ---------------------------------------
      // Total before header discount
      // ---------------------------------------

      totalBeforeHeaderDiscount +=
        _.round(
          amount - lineDiscountAmount,
          2
        );
    }

    // =====================================================
    // STEP 2: Header Discount
    // =====================================================

    const hasLineDiscount =
      this.products.some(
        x => getNum(x.Discount) > 0
      );

    const discountControl =
      this.createQuoteForm.get(
        'DiscountAmount'
      );

    if (hasLineDiscount) {

      if (discountControl?.enabled) {

        discountControl.setValue(
          0,
          {
            emitEvent: false
          }
        );

        discountControl.disable(
          {
            emitEvent: false
          }
        );
      }

    } else {

      if (discountControl?.disabled) {

        discountControl.enable(
          {
            emitEvent: false
          }
        );
      }
    }

    const headerDiscount =
      hasLineDiscount
        ? 0
        : getNum(
          discountControl?.value
        );

    // =====================================================
    // STEP 3: Calculate Line Tax
    // =====================================================

    for (const product of this.products) {

      const quantity =
        getNum(product.QuotedQuantity);

      const weight =
        getNum(product.Weight);

      const amount =
        getNum(product.Amount);

      const discountPercent =
        getNum(product.Discount);

      // ---------------------------------------
      // Discount
      // ---------------------------------------

      const lineDiscountAmount =
        _.round(
          (amount * discountPercent) / 100,
          2
        );

      const netAmount =
        _.round(
          amount - lineDiscountAmount,
          2
        );

      product.NetAmount =
        netAmount;

      product.DiscountAmount =
        lineDiscountAmount;

      // ---------------------------------------
      // Taxable
      // ---------------------------------------

      const isTaxable =
        product.IsTaxable === true;

      const gstRate =
        getNum(product.GSTRate);

      // ---------------------------------------
      // IMPORTANT
      //
      // RCM or LUT:
      // GST is NOT added to Quote total.
      // ---------------------------------------

      let taxAmount = 0;

      if (
        isTaxable &&
        gstRate > 0 &&
        !isRCM &&
        !isLUT
      ) {

        taxAmount =
          _.round(
            (netAmount * gstRate) / 100,
            2
          );
      }

      // ---------------------------------------
      // Reset taxes first
      // ---------------------------------------

      product.CGST = 0;
      product.SGST = 0;
      product.IGST = 0;

      // ---------------------------------------
      // Apply GST
      // ---------------------------------------

      if (taxAmount > 0) {

        if (this.isIGST) {

          product.IGST =
            _.round(
              taxAmount,
              2
            );

          igst +=
            product.IGST;

        } else {

          product.CGST =
            _.round(
              taxAmount / 2,
              2
            );

          product.SGST =
            _.round(
              taxAmount / 2,
              2
            );

          cgst +=
            product.CGST;

          sgst +=
            product.SGST;
        }
      }

      // ---------------------------------------
      // Sales Tax
      // ---------------------------------------

      product.SalesTax =
        _.round(
          product.CGST +
          product.SGST +
          product.IGST,
          2
        );

      // ---------------------------------------
      // Line Total
      // ---------------------------------------

      product.LineTotal =
        _.round(
          netAmount +
          product.SalesTax,
          2
        );

      // ---------------------------------------
      // Taxable Amount
      // ---------------------------------------

      product.TaxableAmount =
        _.round(
          netAmount,
          2
        );

      // ---------------------------------------
      // Taxable / Non-Taxable total
      // ---------------------------------------

      if (isTaxable) {

        taxableTotal +=
          netAmount;

      } else {

        nonTaxableTotal +=
          netAmount;
      }

      // ---------------------------------------
      // Weight
      // ---------------------------------------

      totalWeight +=
        weight > 0
          ? weight
          : quantity;
    }

    // =====================================================
    // STEP 4: Freight
    // =====================================================

    const freightTotal =
      _.round(
        getNum(
          this.createQuoteForm
            .get('FreightTotal')
            ?.value
        ),
        2
      );

    const freightRate =
      _.round(
        getNum(
          this.createQuoteForm
            .get('RateOnFreight')
            ?.value
        ),
        2
      );

    let freightGST = 0;

    // RCM / LUT => no GST on freight
    if (
      freightTotal > 0 &&
      freightRate > 0 &&
      !isRCM &&
      !isLUT
    ) {

      freightGST =
        _.round(
          (
            freightTotal *
            freightRate
          ) / 100,
          2
        );

      if (this.isIGST) {

        igst +=
          freightGST;

      } else {

        cgst +=
          _.round(
            freightGST / 2,
            2
          );

        sgst +=
          _.round(
            freightGST / 2,
            2
          );
      }
    }

    // =====================================================
    // STEP 5: Discount Validation
    // =====================================================

    const maxDiscount =
      _.round(
        totalBeforeHeaderDiscount +
        freightTotal,
        2
      );

    if (
      !hasLineDiscount &&
      headerDiscount > maxDiscount &&
      maxDiscount > 0
    ) {

      if (
        discountControl?.dirty &&
        !discountControl?.hasError(
          'exceedTotal'
        )
      ) {

        this.messageService.clear();

        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Discount',
          detail:
            'Discount cannot be greater than order total.'
        });
      }

      discountControl?.setErrors({
        exceedTotal: true
      });

    } else {

      if (
        discountControl?.hasError(
          'exceedTotal'
        )
      ) {

        discountControl.setErrors(
          null
        );
      }
    }

    // =====================================================
    // STEP 6: Final Taxable Amount
    // =====================================================

    const finalTaxableAmt =
      _.round(
        taxableTotal +
        freightTotal -
        headerDiscount,
        2
      );

    // =====================================================
    // STEP 7: Final Order Total
    // =====================================================

    const totalOrder =
      _.round(
        finalTaxableAmt +
        nonTaxableTotal +
        cgst +
        sgst +
        igst,
        2
      );

    // =====================================================
    // STEP 8: Assign Totals
    // =====================================================

    this.weightTotal =
      _.round(
        totalWeight,
        2
      );

    this.Taxable =
      _.round(
        taxableTotal,
        2
      );

    this.NonTaxableTotal =
      _.round(
        nonTaxableTotal,
        2
      );

    this.FinalTaxableAmt =
      _.round(
        finalTaxableAmt,
        2
      );

    this.CGSTtotal =
      this.isIGST
        ? 0
        : _.round(
          cgst,
          2
        );

    this.SGSTtotal =
      this.isIGST
        ? 0
        : _.round(
          sgst,
          2
        );

    this.IGSTtotal =
      this.isIGST
        ? _.round(
          igst,
          2
        )
        : 0;

    this.SalesTaxTotal =
      _.round(
        this.CGSTtotal +
        this.SGSTtotal +
        this.IGSTtotal,
        2
      );

    this.orderTotal =
      _.round(
        totalOrder,
        2
      );

    // =====================================================
    // STEP 9: Update Form
    // =====================================================

    this.createQuoteForm.patchValue(
      {
        FinalTaxableAmt:
          this.FinalTaxableAmt
      },
      {
        emitEvent: false
      }
    );

    // =====================================================
    // DEBUG
    // =====================================================





    return true;
  }



  calculateGST(price: number, quantity: number, gstrate: number, taxable: boolean): number {
    if (taxable === true) {
      const gst = (price * quantity) * gstrate / 100;
      return gst;
    }
    else {
      return 0;
    }
  }

  async onProductEdit(event: any) {
    let editData = event;
    const productId = editData.ProductId;
    let costCalculationType: string;

    try {
      const productData = await this.getProductById(productId);
      costCalculationType = productData.costCalculation || 'Qty';
    } catch (error) {
      console.error('Failed to fetch product data:', error);
      this.loader = false;
      return;
    }

    if (costCalculationType === 'Qty' && editData.QuotedQuantity <= 0) {
      this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'QuotedQuantity must be greater than 0.' });
      return;
    }

    if (costCalculationType === 'Wgt' && editData.Weight <= 0) {
      this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Weight must be greater than 0.' });
      return;
    }

    let extensionPrice: number;
    if (costCalculationType === 'Qty') {
      extensionPrice = editData.UnitPrice * editData.QuotedQuantity;
    } else if (costCalculationType === 'Wgt') {
      extensionPrice = editData.Weight * editData.UnitPrice;
    } else {
      console.warn('Unknown costCalculation type:', costCalculationType);
      extensionPrice = 0;
    }

    editData.ExtensionPrice = extensionPrice;

    // Discount / Net Amount logic
    const discountPercent = _.toNumber(editData.Discount) || 0;
    if (discountPercent > 100) {
      this.messageService.add({ severity: 'error', summary: 'Invalid Discount', detail: 'Discount percentage cannot be greater than 100%.' });
      return;
    }
    const lineDiscountAmount = _.round((extensionPrice * discountPercent) / 100, 2);
    editData.Discount = discountPercent;
    editData.DiscountAmount = lineDiscountAmount;
    editData.NetAmount = _.round(extensionPrice - lineDiscountAmount, 2);

    editData.SalesTax = (editData.NetAmount * editData.GSTRate) / 100;

    editData.CGST = (!this.isIGST) ? editData.SalesTax / 2 : 0;
    editData.SGST = (!this.isIGST) ? editData.SalesTax / 2 : 0;
    editData.IGST = (this.isIGST) ? editData.SalesTax : 0;

    editData.UnitPrice = _.toNumber(editData.UnitPrice).toFixed(2);

    if (!this.isEdit) {
      const index = this.products.findIndex(product =>
        product.SalesOrderLineItemId === editData.SalesOrderLineItemId);

      if (index !== -1) {
        this.updateSalesOrderLineItems(editData, index);
      } else {
        console.error('Product not found', editData);
        this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while updating product' });
      }
    } else {
      const index = this.products.findIndex(product =>
        product.LineItemNumber === editData.LineItemNumber);

      if (index !== -1) {
        this.products[index] = {
          ...editData,
          ExtensionPrice: editData.ExtensionPrice,
          CGST: editData.CGST,
          SGST: editData.SGST,
          IGST: editData.IGST,
          SalesTax: editData.SalesTax,
          UnitPrice: editData.UnitPrice,
          Discount: editData.Discount,
          DiscountAmount: editData.DiscountAmount,
          NetAmount: editData.NetAmount,
          LineTotal: _.round(editData.NetAmount + editData.SalesTax, 2),
        };
        this.calculateOrderTotal();
      } else {
        console.error('Product not found', editData);
      }
    }

    this.checkLineItemDiscounts();
  }


  updateSalesOrderLineItems(data: Product, index: number) {
    this.salesService.updateSalesOrderLineItem(data).subscribe(
      async (response: any) => {
        if (index !== -1) {
          this.products[index] = {
            ...data,
            ExtensionPrice: data.ExtensionPrice,
            CGST: data.CGST,
            SGST: data.SGST,
            IGST: data.IGST,
            SalesTax: data.SalesTax,
            UnitPrice: data.UnitPrice,
          };
          const isValid = this.calculateOrderTotal();
          if (await isValid) {
            this.createSalesOrder('TEMP.QUOTE');
          }
        }
        this.loader = false;
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while updating product' });
        this.loader = false;
      }
    );
  }


  deleteProduct(reset: boolean = false) {

    this.confirmationService.confirm({
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      message: 'Do you want to delete?',
      accept: () => {

        var selectedProductIds: any
        if (!this.isEdit) {

          if (reset) {
            selectedProductIds = this.products.map(product => product.SalesOrderLineItemId);
          } else {
            selectedProductIds = this.selectedProduct.map(product => product.SalesOrderLineItemId);
          }

          this.loader = true;
          this.salesService.deleteSalesOrderLineItem(selectedProductIds).subscribe({
            next: async (data: any) => {
              if (data) {
                this.loader = false;
                this.products = this.products.filter(product => !selectedProductIds.includes(product.SalesOrderLineItemId));
                this.selectedProduct = [];
                const isValid = this.calculateOrderTotal();
                if (await isValid) {
                  this.createSalesOrder('TEMP.QUOTE');
                }
                if (reset) {
                  setTimeout(() => {
                    const OrderNo = this.createQuoteForm.controls.QuoteNo.value;
                    this.createQuoteForm.reset();
                    this.createQuoteForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
                    this.createQuoteForm.controls.QuoteNo.setValue(_.toString(OrderNo));
                  }, 2000);
                }
              }
            },
            error: error => {
              console.log(error);
              this.loader = false;
              this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while deleting product' });
            }
          });
        } else {
          this.deleteProductIds.push(
            ...this.selectedProduct
              .map(product => product.SalesOrderLineItemId)
              .filter(id => {
                return id && id.toString().trim() !== '';
              })
          );

          selectedProductIds = this.selectedProduct.map(product => product.LineItemNumber);
          this.products = this.products.filter(product => !selectedProductIds.includes(product.LineItemNumber));
          this.selectedProduct = [];
          this.calculateOrderTotal();
        }

      },
      reject: () => {
      }
    });

  }


  reopenQuote() {
    this.route.queryParams.subscribe(params => {
      try {
        const salesOrderId = JSON.parse(params['Data']);
        this.loader = true;
        this.salesService.getSalesOrderById(salesOrderId).subscribe({
          next: (data: any) => {
            if (data) {
              this.isEdit = true;
              const QuoteExpirationDate = data.quoteExpiration ? new Date(data.quoteExpiration) : null;

              this.createQuoteForm.patchValue({
                QuoteNo: data.salesOrderNumber,
                BillToCustomerCode: data.billToCustomerCode,
                BillToCustomerId: data.billToCustomerId,
                BillToCustomer: data.billToCustomer?.customerName,
                ShipToCustomerCode: data.shipToCustomerCode,
                ShipToCustomerId: data.shipToCustomerId,
                ShipToCustomer: data.shipToCustomer?.customerName,
                SalespersonCode: data.salespersonCode,
                SalespersonId: data.salespersonId,
                salesperson: data.salesperson?.salespersonName,
                ShipmentDate: data.shipmentDate ? new Date(data.shipmentDate) : '',
                MotorVehicalNo: data.motorVehicleNo,
                QuoteExpiration: QuoteExpirationDate,
                warehouse: data.warehouse?.warehouseName,
                WareHouseId: data.warehouseId,
                deliveryNote: data.deliveryNote,
                TermsCode: data.termsCode,
                PaymentTermsId: data.paymentTermsId,
                DispatchDocNo: data.dispatchDocNo,
                BillOfLading: data.billOfLading,
                purchaseOrderNumber: data.purchaseOrderNumber,
                LRRRNo: data.lrrrNo,
                DispatchThrough: data.dispatchThrough,
                BillToCustomerAddress: data.billToCustomer?.address
                  ? `${data.billToCustomer.address.state}, ${data.billToCustomer.address.country}, ${data.billToCustomer.address.zip}`
                  : '',
                ShipToCustomerAddress: data.shipToCustomer?.address
                  ? `${data.shipToCustomer.address.state}, ${data.shipToCustomer.address.country}, ${data.shipToCustomer.address.zip}`
                  : '',
                BillToCustomerState: data.billToCustomer?.address?.state,
                warehouseState: data.warehouse?.address?.state,
                orderDate: data.orderDate ? new Date(data.orderDate) : new Date(),
                requestedDate: data.requestedDate ? new Date(data.requestedDate) : null,
                ReferenceNumber: data.referenceNumber,
                Destination: data.destination,
                TermsOfDelivery: data.termsOfDelivery,
                CustomerPODate: data.customerPODate ? new Date(data.customerPODate) : null,
                FreightTotal: data.freightTotal,
                RateOnFreight: data.rateOnFreight,
                GSTOnFreight: data.gstOnFreight,
                DiscountAmount: data.discountAmount,
                FinalTaxableAmt: data.finalTaxableAmt,
                FinancialYearId: data.financialYearId ?? data.FinancialYearId,
                projectBoMId: data.projectBoMId ?? null,
                projectName: data.projectName || data.projectBoM?.projectBoMName || '',
                projectNo: data.projectNo || data.projectBoM?.projectBoMCode || '',

                supplyType: data.supplyType,
                isLUT: data.isLUT ?? false,
                expTyp: data.exportType ?? '',
                isRCM: data.isRCM ?? false,
                POS: data.pos ?? '',
              });

              const orderDate = this.createQuoteForm.get('orderDate')?.value;
              if (orderDate) {
                this.onTransactionDateChange(orderDate, "Order");
              }

              const requestedDate = this.createQuoteForm.get('requestedDate')?.value;
              if (requestedDate) {
                this.onTransactionDateChange(requestedDate, "Requested");
              }
              this.subscribeFinancialYearChanges();

              //Supply type
              this.updateRCMState(data.supplyType);


              setTimeout(() => {
                this.setPlaceOfSupply();
                this.setExportType();
                this.isIGST =
                  this.isIGSTApplicable();
                this.calculateOrderTotal();
              });

              this.deliveryDate = data.requestedDate;
              this.orderTotal = data.orderTotal;
              this.weightTotal = data.totalWeight;
              this.SalesTaxTotal = data.salesTaxTotal;
              this.CGSTtotal = data.cgstTotal;
              this.SGSTtotal = data.sgstTotal;
              this.IGSTtotal = data.igstTotal;

              this.getSalesOrderLineItems(data.salesOrderNumber);
              this.loader = false;
            }
          },
          error: error => {
            console.error(error);
            this.loader = false;
          }
        });
      } catch (error) {
        console.error('Error parsing query param:', error);
      }
    });
  }


  getSalesOrderLineItems(salesOrderNumber: number) {
    this.loader = true;
    this.salesService.getSalesOrderLineItem(salesOrderNumber).subscribe(
      (data: any) => {
        this.products = this.loadProducts(data);
        this.allProductData = this.products;
        this.calculateOrderTotal();
        this.loader = false;
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );
  }

  loadProducts(data: any): Product[] {
    return data.map((item: any) => {
      return this.loadProduct(item);
    });
  }

  loadProduct(data: any) {
    const product: Product = <Product>{
      SalesOrderLineItemId: data.salesOrderLineItemId,
      SalesOrderNumber: data.salesOrderNumber,
      ProductId: data.productId,
      QuotedQuantity: data.quotedQuantity,
      Uom: data.uom,
      LineItemNumber: data.lineItemNumber,
      IsTaxable: data.isTaxable,
      StandardCost: data.standardCost,
      UnitPrice: data.unitPrice,
      ExtensionPrice: data.extensionPrice,
      GSTRate: data.gstRate,
      HSNCode: data.hsnCode,
      CGST: data.cgst,
      SGST: data.sgst,
      IGST: data.igst,
      SalesTax: data.salesTax,
      Weight: data.weight,
      Comment: data.comment,
      deliveryDate: data.deliveryDate ? new Date(data.deliveryDate) : null,
      WareHouseId: data.wareHouseId,
      ProductCode: data.productCode,
      ProductDescription: data.productDescription,
      ProductSpecification: data.productSpecification,
      CreatedBy: data.createdBy,
      IsActive: true,
      DepartmentId: 0,
      LocationId: 0,
      SerialId: 0,
      VendnorId: 0,
      // NEW fields
      Discount: data.discount || 0,
      DiscountAmount: data.discountAmount || 0,
      LineTotal: data.lineTotal || 0,
      NetAmount: data.netAmount || 0,
    }
    return product;
  }

  movetoOrder() {
    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (productCodeAutoCompleteElement) {
        productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    const quoteExpirationControl = this.createQuoteForm.controls.QuoteExpiration;
    if (quoteExpirationControl.value) {
      const currentDate = new Date();
      const expirationDate = new Date(quoteExpirationControl.value);
      if (expirationDate < currentDate) {
        this.messageService.add({ severity: 'error', summary: 'Expired Date', detail: 'Quote expiration date has passed. Cannot move to order.' });
        return;
      }
    }

    this.update(true);
  }

  async update(movetoOrder: boolean = false) {
    const promises: Promise<any>[] = [];
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (!this.validateFinancialYear()) {
      return;
    }

    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (productCodeAutoCompleteElement) {
        productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    for (const product of this.products) {
      if (product.UnitPrice < 0) {
        this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Price cannot be negative.' });
        return;
      }
    }

    for (const product of this.products) {
      try {
        const validProductId = product.ProductId || this.productId;
        const productData = await this.getProductById(validProductId);
        const costCalculationType = productData.costCalculation || 'Qty';

        if (costCalculationType === 'Qty' && product.QuotedQuantity <= 0) {
          this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'QuotedQuantity must be greater than 0.' });
          return;
        }

        if (costCalculationType === 'Wgt' && product.Weight <= 0) {
          this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Weight must be greater than 0.' });
          return;
        }

        if (!product.ProductDescription) {
          this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Product Name is Required' });
          return;
        }
      } catch (error) {
        console.error('Failed to fetch product data:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Unable to fetch product details.' });
        return;
      }
    }

    this.loader = true;
    this.salesService.deleteSalesOrderLineItem(this.deleteProductIds).subscribe({
      next: (data: any) => {
        if (data) {
          this.loader = false;
        }
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });

    for (const product of this.products) {
      if (movetoOrder) {
        product.OrderQuantity = product.QuotedQuantity;
      }

      if (product.deliveryDate) {
        const correctedDate = new Date(product.deliveryDate);
        const currentTime = new Date();
        correctedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
        product.deliveryDate = correctedDate;
      }

      let serviceCall;
      if (product.SalesOrderLineItemId !== undefined && product.SalesOrderLineItemId !== null) {
        this.loader = true;
        serviceCall = this.salesService.updateSalesOrderLineItem(product);
      } else {
        this.loader = true;
        serviceCall = this.salesService.createSalesOrderLineItem(product);
      }

      const promise = serviceCall.toPromise();
      promises.push(promise);
      promise.then(
        (data: any) => {
          this.loader = false;
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
        }
      );
    }

    await Promise.all(promises);

    if (movetoOrder) {
      this.createSalesOrder('ORDER', true);
    } else {
      this.createSalesOrder('QUOTE');
    }
  }



  updateInventory(status: string = "QUOTE") {
    this.loader = true;
    const data = this.createQuoteForm.value;
    const requests = [];

    const itemsToProcess = [
      ...this.allProductData.map(p => ({ ...p, invStatus: status })),
      ...this.deletedProducts.map(p => ({ ...p, invStatus: 'CANCELLED' }))
    ];

    for (let product of itemsToProcess) {
      const productId = product.ProductId || product.id;

      if (productId) {
        const inventory: UpdateInventory = {
          productId: productId,
          warehouseId: _.toNumber(data.WareHouseId),
          productCode: product.ProductCode,
          status: product.invStatus,
          transactionNo: _.toString(data.QuoteNo || ""),
          transactionType: product.invStatus,
          quantity: product.Quantity || product.OrderQuantity,
          createdBy: localStorage.getItem('username')!,
          transactionDate: new Date(),
          createdDate: new Date(),
        };

        requests.push(this.inventoryService.updateInventory(inventory));
      }
    }

    if (requests.length === 0) {
      this.loader = false;
      return;
    }

    forkJoin(requests).subscribe({
      next: () => {
        this.loader = false;
        this.deletedProducts = [];
      },
      error: (error) => {
        console.error(error);
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Inventory Updated failed' });
      }
    });
  }

  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }
  onKeydown(event: KeyboardEvent, product: any) {
    if (event.key === 'Enter' || event.key === 'Tab') {
      event.preventDefault();
      this.onProductEdit(product);
      if (event.key === 'Tab') {
        this.moveFocusToNextField(event, product);
      }
    }
  }

  moveFocusToNextField(event: KeyboardEvent, product: any) {
    const inputs = document.querySelectorAll('input');
    const currentIndex = Array.from(inputs).indexOf(event.target as HTMLInputElement);
    const nextInput = inputs[currentIndex + 1] as HTMLInputElement;

    if (nextInput) {
      nextInput.focus();
    }
  }

  viewProduct(data?: any) {
    const productData = data || this.selectedProduct[0];
    const normalizedData = this.normalizeProductIdInPlace(productData);
    const productDataJson = JSON.stringify(normalizedData);
    this.productId = normalizedData.productId;

    const ref = this.dialogService.open(viewproductLookupComponent, {
      header: 'Product Details',
      width: '70%',
      data: {
        productData: productDataJson,
        productId: this.productId
      }
    });

    let messageShown = false;

    ref.onClose.subscribe(updatedProduct => {
      if (updatedProduct && !messageShown) {
        this.updateProductInGrid(productData, updatedProduct);

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Product updated successfully.`
        });
        messageShown = true;
      }
    });
  }
  updateProductInGrid(originalProduct: any, updatedProduct: any) {
    originalProduct.ProductCode = updatedProduct.ProductCode;
    originalProduct.ProductDescription = updatedProduct.ProductName;
    originalProduct.Uom = updatedProduct.unitsofMeasure || updatedProduct.UnitsOfMeasure;
    originalProduct.HSNCode = updatedProduct.HSNCode;
    originalProduct.GSTRate = +updatedProduct.gstRate || 0;
    originalProduct.UnitPrice = updatedProduct.SalesPrice;
    originalProduct.ExtensionPrice = updatedProduct.
      SalesPrice * originalProduct.QuotedQuantity;
    originalProduct.ProductSpecification = updatedProduct.ProductSpecification;

    const quantity = +originalProduct.QuotedQuantity || 0;
    const unitPrice = +originalProduct.UnitPrice || 0;
    const gstRate = originalProduct.GSTRate;

    const baseAmount = +(unitPrice * quantity).toFixed(2);

    const salesTax = +((baseAmount * gstRate) / 100).toFixed(2);

    originalProduct.TaxableAmount = baseAmount;
    originalProduct.SalesTax = salesTax;
    originalProduct.TotalWithTax = +(baseAmount + salesTax).toFixed(2);
    originalProduct.ExtendedCost = baseAmount;

    if (this.isIGST) {
      originalProduct.IGST = salesTax;
      originalProduct.CGST = 0;
      originalProduct.SGST = 0;
    } else {
      const half = +(salesTax / 2).toFixed(2);
      originalProduct.CGST = half;
      originalProduct.SGST = half;
      originalProduct.IGST = 0;
    }

    this.products = [...this.products];
    this.calculateOrderTotal();
  }




  private normalizeProductIdInPlace(product: any): any {
    if (product && product.ProductId) {
      product.productId = product.ProductId;
      delete product.ProductId;
    }
    return product;
  }
  async toggleEdit(product: Product, field: 'Weight' | 'QuotedQuantity') {
    try {
      const productData = await this.getProductById(product.ProductId);
      const costCalculationType = productData.costCalculation || 'Qty';
      this.isEditingQuantity = false;
      this.isEditingWeight = false;
      if (costCalculationType === 'Qty' && field === 'QuotedQuantity') {
        this.isEditingQuantity = true;
      } else if (costCalculationType === 'Wgt' && field === 'Weight') {
        this.isEditingWeight = true;
      }
    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  }
  getFormControlName(): string {
    return this.productCostCalculationType === 'Qty' ? 'productQty' : 'productWgt';
  }

  getPlaceholder(): string {
    return this.productCostCalculationType === 'Wgt' ? 'Wgt' : 'Qty';
  }

  createQuickProduct() {
    this.submitted = true;

    const isValid = this.validateCustomer();
    if (!isValid) {
      window.scroll(0, 0);
      return;
    }

    this.ref = this.dialogService.open(CloseQuickProductLookupComponent, {
      header: 'Create Quick Product',
      width: '70%',

    });
    this.ref.onClose.subscribe((data: Product) => {
      if (data) {
        const product = { value: data };
        this.setProduct(product);
      }
    });
  }

  showSpecification(productItem: any) {
    if (!productItem.ProductId && !productItem.productId) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Incomplete Product Data.' });
      return;
    }
    this.ref = this.dialogService.open(SpecificationLookupComponent, {
      header: 'Order Line Specification',
      width: '50%',
      data: productItem
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        productItem.ProductSpecification = data.ProductSpecification;
        this.onProductEdit(productItem);
      }
    });
  }

  showProductUom(productItem: Product) {
    this.ref = this.dialogService.open(UOMLookupComponent, {
      header: 'Unit of Measure',
      width: '60%',

    });
    this.ref.onClose.subscribe((selectedUOM: UnitsOfMeasure) => {
      if (selectedUOM) {
        productItem.Uom = selectedUOM.unitsofMeasure;
        this.onProductEdit(productItem);
      }
    });
  }

  createQuickCustomer(status: boolean = true) {
    this.ref = this.dialogService.open(CloseQuickCustomerLookupComponent, {
      header: 'Create Quick Customer',
      width: '70%',

    });
    this.ref.onClose.subscribe((customerId: number) => {
      if (customerId) {
        this.getCustomerData(customerId, status);
      }
    });
  }

  getCustomerData(id: number, status: boolean) {
    this.customerService.getCustomerById(id).subscribe(
      (data: any) => {
        const customerData = {
          value: data
        }
        if (status) {
          this.setBillTo(customerData);
        } else {
          if (data.isShipToCustomer === true) {
            this.setShipTo(customerData);
          } else {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'It cannot be shipped to the customer.' });
          }
        }
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while fetching customer data.' });
      }
    );
  }

  showComment(productItem: Product) {
    this.ref = this.dialogService.open(POCommentsLookupComponent, {
      header: 'Order Line Remark',
      width: '50%',
      data: productItem
    });
    this.ref.onClose.subscribe((data: string) => {
      if (data) {
        productItem.Comment = data;
        this.onProductEdit(productItem);
      }
    });
  }

  getInventoryStatus(productCode: string) {
    const warehouseId = this.createQuoteForm.value.WareHouseId;
    if (!warehouseId) {
      return;
    }
    this.inventoryService.getInventoryStatus(productCode).subscribe({
      next: (data: any) => {
        if (data.success === false) {
        } else {
          const inventoryItem = data.find((item: { warehouseId: any; }) => item.warehouseId === warehouseId);
          if (inventoryItem) {
            this.QAvail = inventoryItem.quantityAvailable;
          } else {
            console.log(`No inventory item found for warehouse ID: ${warehouseId}`);
          }
        }
      },
      error: error => {
        console.log(error);
      }
    });
  }

  // NEW methods
  isLineDiscountDisabled(): boolean {
    const discountAmount = Number(this.createQuoteForm.get('DiscountAmount')?.value) || 0;
    return discountAmount > 0;
  }

  checkLineItemDiscounts() {
    const hasLineDiscount = this.products.some(p => Number(p.Discount) > 0);
    const discountControl = this.createQuoteForm.get('DiscountAmount');
    if (hasLineDiscount) {
      discountControl?.setValue(0, { emitEvent: false });
      discountControl?.disable({ emitEvent: false });
    } else {
      discountControl?.enable({ emitEvent: false });
    }
    this.calculateOrderTotal();
  }

  currentFinancialYear: any;

  loadCurrentFinancialYear() {
    this.salesService.getCurrentFinancialYear().subscribe({
      next: (response: any) => {
        //console.log(response.data.fyName);

        if (!response.data) {

          this.messageService.add({
            severity: 'error',
            summary: 'Financial Year',
            // detail: 'No open Financial Year found for current date.'
            detail: 'No Open Financial Year is available for the current date. Please contact your administrator.'
          });

          return;
        }

        this.currentFinancialYear = response.data;

        this.createQuoteForm.patchValue({
          FinancialYearId: this.currentFinancialYear.fyId
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No open Financial Year found.'
        });
      }
    });
  }

  validateFinancialYear(): boolean {

    const orderDate = this.createQuoteForm.controls.orderDate.value;
    const requestedDate = this.createQuoteForm.controls.requestedDate.value;
    //const requestedDate = this. returnSalesForm.controls.requestedDate.value;

    if (!orderDate) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Order Date is required.'
      });
      return false;
    }

    if (!requestedDate) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Requested Date is required.'
      });
      return false;
    }

    const fy = this.currentFinancialYear;

    if (!fy) {
      this.messageService.add({
        severity: 'error',
        summary: 'Financial Year',
        detail: 'No active Financial Year found.'
      });
      return false;
    }

    // Locked FY
    if (fy.status === 'Locked') {
      this.messageService.add({
        severity: 'error',
        summary: 'Locked Financial Year',
        detail: `Financial Year ${fy.fyName} is Locked.`
      });
      return false;
    }

    // Closed FY
    if (fy.status === 'Closed') {
      this.messageService.add({
        severity: 'error',
        summary: 'Closed Financial Year',
        detail: `Financial Year ${fy.fyName} is Closed.`
      });
      return false;
    }

    const startDate = new Date(fy.startDate);
    const endDate = new Date(fy.endDate);

    const vendiorPayment = new Date(orderDate);

    // Order Date validation
    if (vendiorPayment < startDate || vendiorPayment > endDate) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Order Date',
        detail: `Please select an Order Date within the Financial Year (${this.formatDate(startDate)} to ${this.formatDate(endDate)}).`
      });
      return false;
    }

    // Requested Date validation
    if (requestedDate) {
      const requested = new Date(requestedDate);

      if (requested < startDate || requested > endDate) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Requested Date',
          detail: `Please select a Requested Date within the Financial Year (${this.formatDate(startDate)} to ${this.formatDate(endDate)}).`
        });
        return false;
      }
    }

    return true;
  }

  formatDate(date: Date): string {

    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });

  }

  onTransactionDateChange(date: Date, transaction: string) {
    // if (this.isInitializing) {
    //   return;
    // }
    if (!date) {
      this.currentFinancialYear = null;

      this.createQuoteForm.patchValue({
        FinancialYearId: null
      });

      return;
    }

    this.salesService.getFinancialYearByDate(date).subscribe({
      next: (response: any) => {
        // console.log("Financial Year Response:", response);
        if (!response.success || !response.data) {

          this.currentFinancialYear = null;

          this.createQuoteForm.patchValue({
            FinancialYearId: null
          });

          this.messageService.add({
            severity: 'error',
            summary: 'Financial Year',
            detail: `No Open Financial Year found for the selected ${transaction} date.`
          });

          return;
        }

        this.currentFinancialYear = response.data;

        this.createQuoteForm.patchValue({
          FinancialYearId: response.data.fyId
        });
      },

      error: () => {

        this.currentFinancialYear = null;

        this.createQuoteForm.patchValue({
          FinancialYearId: null
        });

        this.messageService.add({
          severity: 'error',
          summary: 'Financial Year',
          detail: 'Unable to fetch Financial Year.'
        });
      }
    });
  }


  getProjectLookup() {
    this.ref = this.dialogService.open(ProjectBomLookupComponent, {
      header: 'Project List',
      width: '80%',
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.createQuoteForm.patchValue({
          projectBoMId: data.projectBoMId,
          projectName: data.projectBoMName,
          projectNo: data.projectBoMCode
        });
      }
    });
  }

  clearProject() {
    this.createQuoteForm.patchValue({
      projectBoMId: null,
      projectName: '',
      projectNo: ''
    });
  }

  //Suppy Type
  supplyTypes = [
    { code: 'B2B', description: 'Business to Business' },
    { code: 'SEZWP', description: 'SEZ with payment' },
    { code: 'SEZWOP', description: 'SEZ without payment' },
    { code: 'EXPWP', description: 'Export with Payment' },
    { code: 'EXPWOP', description: 'Export without Payment' },
    { code: 'DEXP', description: 'Deemed Export' }
  ];



  getSupplyType(customer: any): string {

    const code = customer.GSTTreatmentCode || customer.gstTreatmentCode || customer.gstTreatment;

    const isSEZ = code === 'SEZ';
    const isOverseas = code === 'OVR';


    if (isOverseas || customer.address?.country !== 'India') {
      return 'EXPORT';
    }

    if (isSEZ || code === 'SEZ') {
      return 'SEZ';
    }

    if (code === 'DEX') {
      return 'DEEMED EXPORT';
    }

    if (code === 'REG') {
      return 'B2B';
    }

    if (code === 'CMP') {
      return 'B2B-COMPOSITION';
    }

    return 'B2C';
  }


  isIGSTApplicable(): boolean {

    const form = this.createQuoteForm.value;

    const supplyType =
      String(form.supplyType || '').trim();

    // Warehouse State Code
    const fromStateCode =
      String(form.warehouseStateCode || '').trim();

    // Customer State Code
    let toStateCode = '';

    switch (supplyType) {

      case 'EXPORT':
      case 'DEEMED EXPORT':
        return true;

      case 'SEZ':

        // SEZ always IGST
        return true;

      case 'B2B':
      case 'B2B-COMPOSITION':

        toStateCode =
          String(
            form.BillToCustomerStateCode || ''
          ).trim();

        break;

      case 'B2C':

        toStateCode =
          String(
            form.ShipToCustomerStateCode ||
            form.BillToCustomerStateCode ||
            ''
          ).trim();

        break;

      default:
        return false;
    }

    if (!fromStateCode || !toStateCode) {
      return false;
    }

    // Interstate check
    return fromStateCode !== toStateCode;
  }

  getLUTLabel(): string {
    const type = this.createQuoteForm.value.supplyType ?? '';

    const map: Record<string, string> = {
      EXPORT: 'Export under LUT (No GST)',
      SEZ: 'Supply to SEZ under LUT (No GST)'
    };

    return map[type] || 'Supply under LUT';
  }

  getExportType(): string {

    const form = this.createQuoteForm.value;

    const type = form.supplyType;
    const isLUT = form.isLUT;

    if (type === 'EXPORT') {
      return isLUT ? 'EXPWOP' : 'EXPWP';
    }

    if (type === 'SEZ') {
      return isLUT ? 'SEZWOP' : 'SEZWP';
    }

    return '';
  }


  setExportType() {

    const form = this.createQuoteForm.value;

    const type = form.supplyType;
    const isLUT = form.isLUT;

    let expTyp = '';

    if (type === 'EXPORT') {
      expTyp = isLUT ? 'EXPWOP' : 'EXPWP';
    } else if (type === 'SEZ') {
      expTyp = isLUT ? 'SEZWOP' : 'SEZWP';
    } else {
      expTyp = '';
    }

    this.createQuoteForm.patchValue({
      expTyp: expTyp
    }, { emitEvent: false });
  }


  private exportTypeMap: Record<string, string> = {
    EXPWOP: 'Export without payment (LUT)',
    EXPWP: 'Export with payment',
    SEZWOP: 'SEZ without payment (LUT)',
    SEZWP: 'SEZ with payment'
  };
  getExportTypeLabel(): string {

    const type = this.createQuoteForm.get('expTyp')?.value ?? '';

    return this.exportTypeMap[type] || '';
  }



  isExportOrSEZ(): boolean {
    const type = this.createQuoteForm.value.supplyType;
    return type === 'EXPORT' || type === 'SEZ';
  }
  validateRCM() {
    const form = this.createQuoteForm.value;

    if (form.isRCM && (form.supplyType === 'EXPORT' || form.supplyType === 'SEZ' || form.supplyType === 'B2C')) {

      this.messageService.add({
        severity: 'warn',
        summary: 'Invalid RCM',
        detail: 'RCM not applicable for this supply type'
      });

      this.createQuoteForm.patchValue({ isRCM: false });
    }
  }

  isRCMDisabled(): boolean {
    const type = this.createQuoteForm.get('supplyType')?.value;

    return type != null && ['EXPORT', 'SEZ', 'B2C'].includes(type);
  }

  setPlaceOfSupply() {

    const form = this.createQuoteForm.value;

    if (form.supplyType === 'EXPORT') {
      this.createQuoteForm.patchValue({
        POSDisplay: 'Other Country',
        POS: '96'
      }, { emitEvent: false });
      return;
    }

    if (form.supplyType === 'B2B') {
      this.createQuoteForm.patchValue({
        POSDisplay: form.BillToCustomerState || '',
        POS: form.BillToCustomerStateCode || ''
      }, { emitEvent: false });
      return;
    }

    const posName = form.ShipToCustomerState || form.BillToCustomerState || '';
    const posCode = form.ShipToCustomerStateCode || form.BillToCustomerStateCode || '';

    this.createQuoteForm.patchValue({
      POSDisplay: posName,
      POS: posCode
    }, { emitEvent: false });

    // console.log("BillToStateCode:", form.BillToCustomerStateCode);
    // console.log("ShipToStateCode:", form.ShipToCustomerStateCode);
  }



  updateRCMState(supplyType: string) {

    const NON_RCM_TYPES = ['EXPORT', 'SEZ', 'B2C'];

    this.showRCM = !NON_RCM_TYPES.includes(supplyType);

    const rcm = this.createQuoteForm.get('isRCM');

    if (!this.showRCM) {
      rcm?.setValue(false, { emitEvent: false });
      rcm?.disable({ emitEvent: false });
    } else {
      rcm?.enable({ emitEvent: false });
    }
  }

  private subscriptions: Subscription[] = [];

  setupFormSubscriptions() {

    const form = this.createQuoteForm;

    const taxTriggers = [
      'supplyType',
      'isLUT',
      'isRCM',
      'BillToCustomerState',
      'ShipToCustomerState',
      'warehouseState'
    ];

    taxTriggers.forEach(field => {

      const sub = form.get(field)?.valueChanges
        .pipe(debounceTime(100))
        .subscribe(() => {

          const value = form.value;

          if (field === 'supplyType' &&
            value.supplyType !== 'EXPORT' &&
            value.supplyType !== 'SEZ') {

            form.patchValue({
              isLUT: false,
              expTyp: ''
            }, { emitEvent: false });
          }

          this.setPlaceOfSupply();

          this.setExportType();
          //this.validateRCM();
          if (field === 'supplyType') {
            this.validateRCM();
          }


          this.calculateOrderTotal();
        });

      if (sub) this.subscriptions.push(sub);
    });


    // const freightRateSub = form.get('RateOnFreight')?.valueChanges
    //   .pipe(debounceTime(100))
    //   .subscribe(() => this.calculateFreightGST());

    // const freightTotalSub = form.get('FreightTotal')?.valueChanges
    //   .pipe(debounceTime(100))
    //   .subscribe(() => this.calculateFreightGST());

    // if (freightRateSub) this.subscriptions.push(freightRateSub);
    // if (freightTotalSub) this.subscriptions.push(freightTotalSub);


    // const discountSub = form.get('DiscountAmount')?.valueChanges
    //   .pipe(debounceTime(100))
    //   .subscribe(() => this.calculateOrderTotal());

    // if (discountSub) this.subscriptions.push(discountSub);
  }

  async onRCMChange(event: any) {
    const isRCM = event.checked === true;

    //console.log('RCM changed:', isRCM);

    // Recalculate current products
    await this.calculateOrderTotal();

    // If there are already saved line items,
    // update them in database
    if (this.products?.length > 0) {
      for (const product of this.products) {

        if (!product.SalesOrderLineItemId) {
          continue;
        }

        // console.log('Updating RCM line item:', {
        //   id: product.SalesOrderLineItemId,
        //   CGST: product.CGST,
        //   SGST: product.SGST,
        //   IGST: product.IGST,
        //   SalesTax: product.SalesTax,
        //   NetAmount: product.NetAmount,
        //   LineTotal: product.LineTotal
        // });

        try {
          await this.salesService
            .updateSalesOrderLineItem(product)
            .toPromise();

        } catch (error) {
          console.error(
            'Error updating RCM line item:',
            error
          );
        }
      }
    }
  }

  async onLUTChange(event: any) {
    const isLUT = event.checked === true;

    //console.log('LUT changed:', isLUT);

    // Recalculate all line items
    await this.calculateOrderTotal();

    if (this.products?.length > 0) {
      for (const product of this.products) {

        if (!product.SalesOrderLineItemId) {
          continue;
        }

        // console.log('Updating LUT line item:', {
        //   id: product.SalesOrderLineItemId,
        //   CGST: product.CGST,
        //   SGST: product.SGST,
        //   IGST: product.IGST,
        //   SalesTax: product.SalesTax,
        //   NetAmount: product.NetAmount,
        //   LineTotal: product.LineTotal
        // });

        try {
          await this.salesService
            .updateSalesOrderLineItem(product)
            .toPromise();

        } catch (error) {
          console.error(
            'Error updating LUT line item:',
            error
          );
        }
      }
    }
  }


}